import { useState } from 'react';
import { EDirection } from '@svitlofour/types';

export const useDirection = () => {
  const [direction, setDirection] = useState<EDirection | undefined>(undefined);

  return { direction, setDirection };
};
